import React from 'react';
import PropTypes from 'prop-types';
import SignUp from './SignUp';
import Profile from './Profile';
import Modal from './Modal';
import './LoginModal.scss';

export default function SignUpModal(props) {
  // 1. ADDED DEFAULT FALLBACK: page = 'signup'
  const { isOpen, onRequestClose, page = 'signup' } = props;
  const isCloseable = true;
  
  // Ensure we have a valid function even if props.onRequestClose is missing
  const handleRequestClose = isCloseable ? onRequestClose : () => {};

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      className={`${page}-modal`}
      showCloseButton={isCloseable}
    >
      {/* 2. Now 'page' defaults to 'signup' and correctly triggers this first condition */}
      {page === 'signup' || page === 'login' ? (
        <SignUp {...props} />
      ) : (
        <Profile {...props} />
      )}
    </Modal>
  );
}

SignUpModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  page: PropTypes.string,
  ...SignUp.propTypes
};

